import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import server from '../../../api/server';
import { fetchApplication } from '../../../actions';
import Card from '../ui/Card';
import Button from '../ui/Button';
import DocRequestChecklist from './DocRequestChecklist';
import { DocumentIcon } from '../ui/icons';

// Redesign of newadmin/elements/RequestDocCollection.js — same
// /docrequest/create payload shape ({ organisation_id, state, application_id })
// followed by fetchApplication.
const RequestDocCollectionCard = () => {
    const activeApplication = useSelector((s) => s.admin.active_application);
    const organisation = useSelector((s) => s.organisation);
    const dispatch = useDispatch();

    const [applicants, setApplicants] = useState({});

    const buildApplicants = () => {
        const next = {};
        Object.keys(activeApplication.application.applicants).forEach((key) => {
            const files = [];
            organisation.file_upload_settings.files.forEach((file, index) => {
                files.push({
                    label: file.label,
                    description: file.description,
                    min_documents: file.min_documents,
                    index: index,
                    category: file.category,
                    requested: false,
                });
            });
            next[key] = {
                name: activeApplication.application.applicants[key].name,
                files: [...files],
            };
        });
        setApplicants(next);
    };

    // Port of componentDidMount + the applicant-count sync in
    // componentDidUpdate.
    useEffect(() => {
        buildApplicants();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Object.keys(activeApplication.application.applicants).length]);

    const toggleFile = (applicantKey, fileIndex) => {
        const next = { ...applicants };
        next[applicantKey].files[fileIndex].requested = !next[applicantKey].files[fileIndex].requested;
        setApplicants(next);
    };

    const selectAll = (applicantKey) => {
        const next = { ...applicants };
        next[applicantKey].files.forEach((file) => {
            file.requested = true;
        });
        setApplicants(next);
    };

    const createDocRequest = async () => {
        const response = await server.post('/docrequest/create', {
            organisation_id: organisation.id,
            // Original sent the whole component state ({ test, applicants }).
            state: { test: true, applicants },
            application_id: activeApplication.application.id,
        });
        if (response.data) {
            dispatch(fetchApplication(activeApplication.application.id));
        }
    };

    return (
        <Card title="Request Document Collection" icon={<DocumentIcon className="h-5 w-5" />}>
            <DocRequestChecklist applicants={applicants} onToggle={toggleFile} onSelectAll={selectAll} />
            <div className="mt-5 flex justify-end">
                <Button onClick={createDocRequest}>Request Document Collection</Button>
            </div>
        </Card>
    );
};

export default RequestDocCollectionCard;
